import { sidesporSemanticsForEventType } from "features/CenterContent/RoleContent/AlternativeTransport/MeasureOverview/MeasureOverviewColumn/MeasureCard/semanticFunctions";
import { FC } from "react";
import { Badge, Flex } from "shared/components/Spor";
import { CombinedHistoryResponse } from "shared/types/operationalInformation";
import { semanticToDataColor } from "shared/utils/semanticColorPalette";

type MeasureCardEventBadgesProps = {
  informationType: CombinedHistoryResponse["type"];
  informationState: CombinedHistoryResponse["state"];
  isClosedOrWithdrawn: boolean;
};

export const MeasureCardEventBadges: FC<MeasureCardEventBadgesProps> = ({
  informationType,
  informationState,
  isClosedOrWithdrawn,
}) => (
  <Flex wrap="wrap" gap={1}>
    <Badge
      size="md"
      data-color={semanticToDataColor(
        sidesporSemanticsForEventType(
          informationType.type,
          isClosedOrWithdrawn,
        ),
      )}
      textDecor={isClosedOrWithdrawn ? "line-through" : "initial"}
    >
      {informationType.label}
    </Badge>

    {informationState === "CLOSED" && (
      <Badge size="md" data-color="success">
        Friskmeldt
      </Badge>
    )}
  </Flex>
);
